<template>
    <div>
        <div class="text-tc-blue-2 text-20">{{ FiltertDateFormatShortMonthWithTimeNotUtc(campaign.timestamp) }}</div>
        <div class="flex">
            <div class="flex-grow text-tc-gray-3 text-22 font-main-medium break-all"> {{ getCampaignName() }} </div>
            <div class="text-tc-blue-1 text-22 font-bold text-right pl-5 flex-initial w-28">
                <div class="ml-auto">
                    <span>+{{FilterNumberFormat(campaign.points)}} </span>
                    <!-- <span> +{{FilterNumberFormat(10000)}} </span> -->
                    <img class="w-5 inline-block" src="@/assets/icon/coin-point.png">
                </div>
            </div>
        </div>
        <div class="line my-10px bg-tc-gray-4"></div>
    </div>
</template>

<script>
import Util from '@/helper/Utility.js';
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: 'HistoryRedeemReceive',
    mixins: [LocaleMixin],
    props:{
       campaign: Object,
       keyIndex: Number,
    },
    methods: {
        getCampaignName: function() {
            if (this.campaign.type == 'adjust') {
                let msg = Util.jsonParse(this.campaign.message);
                if (msg != null && !Util.isEmptyStr(msg.PolicyNumber)) {
                    return msg.PolicyNumber;
                }
                return 'Adjust Point'
            } else if (this.campaign.type == 'maaitobzbs') {
                return this.lbl.TransferMAAI.receive_from_maai;
            } else if (this.campaign.type == 'transfer') {
                // return this.lbl.TransferMAAI.transfer_earn;
                if (this.campaign.inputJson && this.campaign.inputJson.Source && this.campaign.inputJson.Source.ContactNumber) {
                    return this.lbl.TransferMAAI.transfer_earn + " " + this.formatContactNumber(this.campaign.inputJson.Source.ContactNumber + "");
                }
            } else {
                if (this.campaign.inputJson && this.campaign.inputJson.Source && this.campaign.inputJson.Source.ContactNumber) {
                    return  this.lbl.history.earn_coin_from + " " + this.formatContactNumber(this.campaign.inputJson.Source.ContactNumber + "");
                }
            }
            if (Util.isEmptyStr(this.campaign.campaignName)) {
                return '-';
            }
            return this.campaign.campaignName;
        },
        formatContactNumber: function(strNumber) {
            //convert to format 088-888-XXXX
            if (strNumber) {
                return strNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2xxxx');
            }

            return '';
        },
    },
};
</script>

<style lang="scss" scoped>
.line{
    height: 0.5px;
    transform: rotate(-180deg);
}
</style>
